/* eslint-disable no-unused-vars */
import Accordion from 'accordion-js';

function servicesAccordion() {
    const heroModules = document.querySelectorAll('.servicesAccordion__module');
    heroModules.forEach((module) => {
        const moduleTarget = module.querySelector('.servicesAccordion__target');
        const moduleContent = module.querySelector('.servicesAccordion__content');

        const mediaQuery = '(min-width: 921px)';
        const mediaQueryList = window.matchMedia(mediaQuery);

        function setAttributes() {
            // find first module
            const firstModule = document.querySelector('.servicesAccordion__module:first-of-type');
            firstModule.classList.add('active');

            // add unique id to each moduleContent
            const moduleContentId = moduleContent.getAttribute('id');

            moduleTarget.setAttribute('aria-haspopup', 'true');
            moduleTarget.setAttribute('aria-controls', moduleContentId);

            // get index of module
            const moduleIndex = Array.prototype.indexOf.call(heroModules, module);
            // if moduleIndex is 0, set aria attributes
            if (moduleIndex === 0) {
                moduleTarget.setAttribute('aria-expanded', 'true');
                moduleContent.setAttribute('aria-hidden', 'false');
            } else {
                moduleTarget.setAttribute('aria-expanded', 'false');
                moduleContent.setAttribute('aria-hidden', 'true');
            }
        }

        function unsetAttributes() {
            module.classList.remove('active');
            moduleTarget.removeAttribute('aria-haspopup');
            moduleTarget.removeAttribute('aria-controls');
            moduleTarget.removeAttribute('aria-expanded');
            moduleContent.removeAttribute('aria-hidden');
        }

        mediaQueryList.addEventListener('change', event => {
            if (event.matches) { // > 641px
                setAttributes();
            } else { // < 640px
                unsetAttributes();
            }

        });

        // check mediaQueryList on page load
        if (mediaQueryList.matches) { // > 641px
            setAttributes();
        } else { // < 641px
            unsetAttributes();
        }

        moduleTarget.addEventListener('click', () => {
            if (mediaQueryList.matches) { // > 641px
                  
                // if module is already active, return
                if (module.classList.contains('active')) {
                    return;
                }
                // close all other modules
                heroModules.forEach((module) => {
                    module.classList.remove('active');
                    module.querySelector('.servicesAccordion__target').setAttribute('aria-expanded', 'false');
                    module.querySelector('.servicesAccordion__content').setAttribute('aria-hidden', 'true');
                });

                module.classList.toggle('active');
                moduleTarget.setAttribute('aria-expanded', 'true');
                moduleContent.setAttribute('aria-hidden', 'false');

            }

        });

    });

    const accordions = Array.from(document.querySelectorAll('.servicesAccordionVert__items'));

    if (!accordions.length) {
        return;
    }
    // Init with options
    new Accordion(accordions, {
        duration: 400,
        showMultiple: false,
        elementClass: 'servicesAccordionVert__item',
        triggerClass: 'servicesAccordionVert__target',
        panelClass: 'servicesAccordionVert__content',
        openOnInit: [0],
        onOpen: (currElement) => {
            window.dispatchEvent(new Event('resize'));
        },
        onClose: (currElement) => {
            window.dispatchEvent(new Event('resize'));
        }
    });

}


/**
 * Function to run when this module is called from site.js
 */
const init = () => {

    servicesAccordion();
    
};

export default init;
